import { CopyFilled, ReloadOutlined } from "@ant-design/icons";
import { Button, message } from "antd";
import { bg_button, bg_shadow } from "constant/css";
import GetAccountRemainInfo from "functions/admin/getAccountRemainInfo";
import moneyFormat from "functions/utils/moneyFormat";
import { useEffect, useState } from "react";

const AccountDetail = ({ account }) => {
  const [item, setItem] = useState(account);
  const [loading, setLoading] = useState(false);
  const { data } = item;
  const balance =
    data && data.currentRemain && data.waitingSettleAmount
      ? parseFloat(data.currentRemain) - parseFloat(data.waitingSettleAmount)
      : 0;

  useEffect(() => {
    fetchRemain();
  }, [account]);
  const fetchRemain = async () => {
    setLoading(true);
    const response = await GetAccountRemainInfo(account.accountNumber);
    setItem({
      ...account,
      data: response ? response.data : null,
    });
    setLoading(false);
  };
  const renderBankIcon = (bankName) => {
    switch (bankName) {
      case "KHAN BANK":
        return (
          <img
            src="/bank/khan.png"
            alt="Khan Bank"
            className="w-8 h-8 rounded-lg"
          />
        );
      case "TDB BANK":
        return (
          <img
            src="/bank/tdb.png"
            alt="TDB Bank"
            className="w-8 h-8 rounded-lg"
          />
        );
      default:
        return <span className="text-gray-500">Банк!</span>;
    }
  };
  const copy = (text) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        message.success("хуулагдлаа!");
      })
      .catch(() => {
        message.error("хуулахад алдаа гарлаа.");
      });
  };
  const reLoad = () => {
    fetchRemain();
  };
  return (
    <div key={item.id} className={`rounded-xl ${bg_button} ${bg_shadow} p-6`}>
      {/* Header */}
      <div className="flex justify-between items-start">
        <div className="flex items-center flex-row space-x-3">
          {renderBankIcon(item.bankName)}
          <p className="text-sm text-gray-100 font-bold">{item.bankName}</p>
          <Button onClick={reLoad} className="bg-transparent">
            <ReloadOutlined style={{ color: "white" }} />
          </Button>
        </div>
        <div>
          <div className="text-right flex flex-row">
            <p className="text-xs text-gray-300 mr-1">Данс</p>
            <p className="text-xs text-green-100 font-medium mr-2">
              {item.accountNumber}
            </p>
            <CopyFilled
              style={{ color: "#fff" }}
              onClick={() => copy(item.accountNumber)}
            />
          </div>
          <div className="text-right flex flex-row">
            <p className="text-xs text-gray-300 mr-1">iBAN</p>
            <p className="text-xs text-green-100 font-medium mr-2">
              {item.iban}
            </p>
            <CopyFilled
              style={{ color: "#fff" }}
              onClick={() => copy(item.iban)}
            />
          </div>
        </div>
      </div>

      {/* Data block */}
      <div className="mt-5 space-y-3 text-sm">
        {data ? (
          <>
            <div className="flex justify-between">
              <span className="text-gray-200">Одоогийн үлдэгдэл</span>
              <span className="text-gray-100 font-semibold">
                {moneyFormat(data.currentRemain)} ₮
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-200">Хүлээгдэж буй шилжүүлэг</span>
              <span className="text-[#fcce9f] font-semibold">
                {moneyFormat(data.waitingSettleAmount)} ₮
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-200">Шилжүүлсэн дүн(Өнөөдөр)</span>
              <span className="text-[#fcce9f] font-semibold">
                {moneyFormat(data.todaysSettledAmount)} ₮
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-200">Зөрүү үлдэгдэл</span>
              <span
                className={`font-semibold ${
                  balance >= 0 ? "text-[#79f6fc]" : "text-red-500"
                }`}
              >
                {moneyFormat(balance)} ₮
              </span>
            </div>
          </>
        ) : (
          <div className="text-white text-center pt-4">
            ⚠️ Мэдээлэл олдсонгүй
          </div>
        )}
      </div>
    </div>
  );
};

export default AccountDetail;
